// removed by extract-text-webpack-plugin
module.exports = {"overlay":"Popover__overlay__1Zq0I","open":"Popover__open__3r724","popover":"Popover__popover__P5i-l"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Popover/Popover.scss
// module id = 1731
// module chunks = 0